module.exports = __webpack_public_path__ + "assets/img/img-sp.png";